export default __webpack_public_path__ + "static/media/edit-icon.f1343460.svg";